const transatelDataRecharge = {
  index: {
  },
  tab: {
    main: "Recharge",
  },
  new: {
    title: "Nouvelle recharge mobile Transatel"
  },
  search: {
    transatelPreviousThreshold: "Palier précédent"
  }
};

export default transatelDataRecharge;
